import React from 'react';
import styles from './styles.module.css';

import PillButton from '../../../pill-button';
import SubHeading from '../../../sub-heading';

export default ({ setForm, closeForm }) => (
  <div className={styles.container}>
    <SubHeading text="Select a method" />
    <p>How would you like to contribute?</p>
    <div className={styles.twoButtons}>
      <PillButton
        theme="blue"
        text="Edit details"
        onClick={() => setForm('editItem')}
      />
      <PillButton
        theme="blue"
        text="Upload images"
        onClick={() => setForm('images')}
      />
    </div>
    <div className={styles.twoButtons}>
      <PillButton
        theme="blue"
        text="Submit details"
        onClick={() => setForm('general')}
      />
      <PillButton
        theme="blue"
        text="Add a memory"
        onClick={() => setForm('memory')}
      />
    </div>

    <PillButton theme="grey-ghost" text="Cancel" onClick={closeForm} />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/contribution-form/forms/select-form/index.js